/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClaimProgressComponent} from './claim-progress.component';
import {ClaimProgressStepComponent} from './claim-progress-step.component';
import {TooltipModule} from '../../../shared/tooltip/tooltip.module';
import {TooltipPersistentModule} from '../../../shared/tooltip-persistent/tooltip-persistent.module';
import {ConfirmModalModule} from '../../../shared/confirm-modal/deprecated-modals/confirm-modal.module';
import {ClaimProgressMarkerComponent} from './claim-progress-marker.component';
import {ConfirmModalGeneralModule} from '../../../shared/confirm-modal/deprecated-modals/confirm-modal-general/confirm-modal-general.module';

@NgModule({
    declarations: [ClaimProgressComponent, ClaimProgressStepComponent, ClaimProgressMarkerComponent],
    exports: [
        ClaimProgressComponent
    ],
    imports: [
        CommonModule,
        TooltipModule,
        TooltipPersistentModule,
        ConfirmModalModule,
        ConfirmModalGeneralModule
    ]
})
export class ClaimProgressModule {
}
